import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";
import AuthShell from "@/pages/AuthShell";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Spinner } from "@/components/Loading";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("تم تسجيل الدخول بنجاح");
      nav("/app");
    } catch (err) {
      const msg = formatApiError(err.response?.data?.detail) || err.message;
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell
      title="تسجيل الدخول"
      subtitle="أدخل بياناتك للوصول إلى حسابك"
      footer={<>ليس لديك حساب؟ <Link to="/register" className="font-semibold text-greenx">إنشاء حساب</Link></>}
    >
      <form onSubmit={submit} className="space-y-4">
        <div>
          <Label className="text-start">البريد الإلكتروني</Label>
          <Input data-testid="login-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)}
            placeholder="name@example.com" required className="mt-1.5 rounded-lg" />
        </div>
        <div>
          <Label className="text-start">كلمة المرور</Label>
          <Input data-testid="login-password" type="password" value={password} onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••" required className="mt-1.5 rounded-lg" />
        </div>
        {error && <p data-testid="login-error" className="rounded-lg bg-red-50 px-4 py-2 text-sm text-red-600">{error}</p>}
        <Button data-testid="login-submit" type="submit" disabled={loading} className="w-full rounded-lg bg-navy py-6 hover:bg-navy-light active:scale-[0.98]">
          {loading ? <Spinner className="h-5 w-5 border-white/40 border-t-white" /> : "دخول"}
        </Button>
      </form>
    </AuthShell>
  );
}
